import { Paragraph } from '@zillow/constellation-10';

type Props = {
  outcomeStats: number;
  source: string;
};

const WizardTipContent = ({ outcomeStats, source }: Props) => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        Properties that allow pets can receive up to {outcomeStats}% more contacts than those that don&apos;t, based on
        data for other listings with a similar price.
      </Paragraph>
      <Paragraph textStyle="body-xs" color="text.subtle" css={{ marginTop: '400' }}>
        {source}
      </Paragraph>
    </div>
  );
};

export default WizardTipContent;
